module.exports = __webpack_public_path__ + "img/close-2.cdf385a0.svg";